import * as React from 'react'

import { RequestTypeDetailDocument } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'
import { NavigationRoutesFn } from 'modules/core/lib/react-router'

const PurchaseRequestsSettingsPage = React.lazy(
  () => import('modules/procurement/pages/SettingsPage')
)

const RequestTypeDetailPage = React.lazy(
  () => import('modules/procurement/pages/RequestTypeDetailPage')
)

const settingsRoutes: NavigationRoutesFn = (navigation) => {
  return [
    {
      path: navigation.settings.procurement.path,
      children: [
        {
          index: true,
          element: <PurchaseRequestsSettingsPage />,
          handle: {
            meta: () => ({
              title: i18n.t('company_settings.finance.procurement.title'),
              illustration: 'receipt',
            }),
          },
        },
        {
          path: navigation.settings.procurement.requestType.path,
          children: [
            {
              path: navigation.settings.procurement.requestType.id.path,
              element: <RequestTypeDetailPage />,
              handle: {
                resource: true,
                meta: ({ watchQuery, params, session }) => {
                  return watchQuery({
                    query: RequestTypeDetailDocument,
                    variables: {
                      requestTypeId: String(params.id),
                      companyId: session.company.id,
                    },
                  }).map(({ data }) => {
                    const requestType = data?.procurement?.typesConnection?.nodes?.[0]

                    return {
                      title:
                        requestType?.name ||
                        i18n.t('procurement.purchase_requests.settings.types.detail.breadcrumb'),
                      illustration: 'receipt',
                      ancestors: [
                        {
                          title: i18n.t('company_settings.finance.procurement.title'),
                          to: navigation.settings.procurement.fullPath(),
                        },
                      ],
                    }
                  })
                },
              },
            },
          ],
        },
      ],
    },
  ]
}

export default settingsRoutes
